export default "__VITE_ASSET__B1Wsl4xe__"